var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view"},[_c('div',{staticClass:"list"},_vm._l((_vm.list),function(item){return _c('div',{key:item.id,staticClass:"item"})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }